import React from 'react';
import Card from 'components/Card';
import security from 'stores/security';
import Header from './components/Header';
import ProcessingRecords from './components/ProcessingRecords';
import Table from './components/Table';
import './style.scss';

const FundingRecords = () => {
    return (
        <Card page>
            <div className="funding-records-root">
                <Header />
                {security.isMarscoAuditing ? <ProcessingRecords /> : <Table />}
            </div>
        </Card>
    );
};

export default FundingRecords;
